<div class="coverage-container">
    <div class="coverage-stats" *ngIf="coverage">
        <div class="coverage-stat">
            <div class="stat-value">{{coverage.coveragePct | number:'1.0-1'}}%</div>
            <div class="stat-label">Coverage</div>
        </div>
        <div class="coverage-stat">
            <div class="stat-value">{{coverage.totalJourneys | number:'1.0-0'}}</div>
            <div class="stat-label">Total Journeys</div>
        </div>
        <div class="coverage-stat">
            <div class="stat-value">{{coverage.coveredJourneys | number:'1.0-0'}}</div>
            <div class="stat-label">With Rules</div>
        </div>
        <div class="coverage-stat">
            <div class="stat-value">{{coverage.uncoveredJourneys | number:'1.0-0'}}</div>
            <div class="stat-label">Without Rules</div>
        </div>
        <div class="coverage-stat">
            <div class="stat-value">{{coverage.distinctRules | number:'1.0-0'}}</div>
            <div class="stat-label">Distinct Rules</div>
        </div>
    </div>
    <div class="coverage-by-type" *ngIf="coverage && coverage.byRuleType.length">
        <span class="by-type-item" *ngFor="let ruleType of coverage.byRuleType">
            {{ruleType.ruleType}}: {{ruleType.journeys | number:'1.0-0'}} ({{ruleType.pctOfTotal | number:'1.0-1'}}%)
        </span>
    </div>
    <kendo-grid [data]="tableGrid.gridData"
                [sortable]="true"
                [sort]="tableGrid.gridSort"
                (sortChange)="tableGrid.sortChange($event)"
                [rowHeight]="tableGrid.options.rowHeight"
                [loading]="isLoading"
                [height]="rowHt - 160"
                [scrollable]="'virtual'">
        <kendo-grid-column title="Rule" field="ruleName" [headerClass]="'ra-grid-header'"></kendo-grid-column>
        <kendo-grid-column title="Type" field="ruleType" [width]="110" [headerClass]="'ra-grid-header'"></kendo-grid-column>
        <kendo-grid-column title="Journeys" field="journeys" format="{0:n0}" [width]="90"
                           [headerClass]="['ra-grid-header', 'col-pull-right']"
                           [class]="'col-pull-right'"></kendo-grid-column>
    </kendo-grid>
</div>
